import { Injectable, EventEmitter } from '@angular/core'
import { HttpClient } from '@angular/common/http';
import { MEAT_API } from '../app.api'
import { Resposta } from '../app.response';
import { Router } from '@angular/router'
import { LoginModel } from '../login/login-model';
import { ClienteModel } from '../cliente/cliente-model';
import { CepModel } from '../helpers/cep-model';
import { EmpresaModel } from '../models/empresa-model';
import { FinanceiroModel } from '../financeiro/financeiro-model';
import { ContasReceberModel } from '../models/contas-receber-model';
import { SetorModel } from '../models/setor-model';
import { CarteiraModel } from '../carteira/carteira-model';
import { ComercialModel } from '../comercial/comercial-model';
import { TecnicaModel } from '../tecnica/tecnica-model';
import { FuncionarioModel } from '../helpers/funcionario-model';
import { GrupoModel } from '../models/grupo-model';
import { VistoriaModel } from '../vistoria/vistoria-model';
import { FaturamentoModel } from '../faturamento/faturamento.model';
import { CodigoAtendimentoModel } from '../models/codigo-atendimento.model';

@Injectable()
export class Services {

  constructor(private http: HttpClient, private router: Router) { }

  private usuarioAutenticado: boolean = false;

  mostrarMenu = new EventEmitter<boolean>();

  //EMPRESA

  listarEmpresas() {
    return this.http.get<Resposta<EmpresaModel[]>>(`${MEAT_API}/api/empresas/listaEmpresas`);
  }

  //FIM EMPRESA

  listarFuncionario() {
    return this.http.get<Resposta<FuncionarioModel[]>>(`${MEAT_API}/api/funcionarios/listaFuncionarios`);
  }
  listarCliente() {
    return this.http.get<Resposta<ClienteModel[]>>(`${MEAT_API}/api/cliente/listaCliente`);
  }

  listarGrupo() {
    return this.http.get<Resposta<GrupoModel[]>>(`${MEAT_API}/api/grupo/listaGrupo`);
  }

  listarSetor() {
    return this.http.get<Resposta<SetorModel[]>>(`${MEAT_API}/api/empresas/listaSetor`);
  }

  Login(usuario: LoginModel) {
    return this.http.post<Resposta<LoginModel>>(`${MEAT_API}/api/usuarios/autenticacao`, usuario);
  }

  //FINANCEIRO
  listarFinanceiro(dados: FinanceiroModel) {
    return this.http.post<Resposta<FinanceiroModel[]>>(`${MEAT_API}/api/cliente/buscaFinanceiro`, dados);
  }

  listarFinanceiroOrigem(dados: ContasReceberModel) {
    return this.http.post<Resposta<ContasReceberModel[]>>(`${MEAT_API}/api/cliente/buscaFinanceiroOrigem`, dados);
  }

  // FIM FINANCEIRO
  gravarDadosCliente(dados: ClienteModel) {
    return this.http.post<Resposta<ClienteModel>>(`${MEAT_API}/api/cliente/cadastrarCliente/`, dados);
  }
  removerDadosCliente(dados: ClienteModel) {
    return this.http.post<Resposta<ClienteModel>>(`${MEAT_API}/api/cliente/removerCliente/`, dados);
  }
  listarClientes() {
    return this.http.get<Resposta<ClienteModel[]>>(`${MEAT_API}/api/cliente/buscaCliente`);
  }

  listarClientesFiltros(filtro: ClienteModel) {
    return this.http.post<Resposta<ClienteModel[]>>(`${MEAT_API}/api/cliente/buscaClienteFiltros/`, filtro);
  }

  buscaCep(filtro: string) {
    return this.http.get<CepModel>(`https://viacep.com.br/ws/${filtro}/json/`);
  }


  //CARTEIRA
  listarCarteira(dados: CarteiraModel) {
    return this.http.post<Resposta<CarteiraModel[]>>(`${MEAT_API}/api/cliente/buscaCarteira`, dados);
  }
  listarCarteiraOrigem(dados: CarteiraModel) {
    return this.http.post<Resposta<CarteiraModel[]>>(`${MEAT_API}/api/cliente/buscaCarteiraOrigem`, dados);
  }

  //COMERCIAL
  listarComercial(dados: ComercialModel) {
    return this.http.post<Resposta<ComercialModel[]>>(`${MEAT_API}/api/cliente/buscaComercial`, dados);
  }
  listarComercialOrigem(dados: ComercialModel) {
    return this.http.post<Resposta<ComercialModel[]>>(`${MEAT_API}/api/cliente/buscaComercialOrigem`, dados);
  }

  //VISTORIA
  listarVistoria(dados: VistoriaModel) {
    return this.http.post<Resposta<VistoriaModel[]>>(`${MEAT_API}/api/cliente/buscaVistoria`, dados);
  }
  listarVistoriaOrigem(dados: VistoriaModel) {
    return this.http.post<Resposta<VistoriaModel[]>>(`${MEAT_API}/api/cliente/buscaVistoriaOrigem`, dados);
  }

  //VISTORIA MANUTENCAO
  listarVistoriaManutencao(dados: VistoriaModel) {
    return this.http.post<Resposta<VistoriaModel[]>>(`${MEAT_API}/api/cliente/buscaVistoria`, dados);
  }
  listarVistoriaManutencaoOrigem(dados: VistoriaModel) {
    return this.http.post<Resposta<VistoriaModel[]>>(`${MEAT_API}/api/cliente/buscaVistoriaOrigem`, dados);
  }
  listarVendedor() {
    return this.http.get<Resposta<FuncionarioModel[]>>(`${MEAT_API}/api/funcionarios/listaVendedores`);
  }

  //TÉCNICA
  listarTecnica(dados: TecnicaModel) {
    return this.http.post<Resposta<TecnicaModel[]>>(`${MEAT_API}/api/cliente/buscaTecnica`, dados);
  }
  listarTecnicaOrigem(dados: TecnicaModel) {
    return this.http.post<Resposta<TecnicaModel[]>>(`${MEAT_API}/api/cliente/buscaTecnicaOrigem`, dados);
  }
  logout() {
    localStorage.removeItem('currentUser');
  }

  //CHAMADA TÉCNICA
  listarChamadaTecnica() {
    return this.http.get<Resposta<TecnicaModel[]>>(`${MEAT_API}/api/cliente/buscaChamadaTecnica`);
  }

  //LOCALIZAÇÃO
  Buscar() {
    return this.http.get<Resposta<FuncionarioModel[]>>(`${MEAT_API}/v1/cliente/listarLocalizacaoTecnico`);
  }
  BuscarCliente() {
    return this.http.get<Resposta<ClienteModel[]>>(`${MEAT_API}/v1/localizacaochamada/listarLocalizacaoCliente`);
  }
  BuscarChamada() {
    return this.http.get<Resposta<TecnicaModel[]>>(`${MEAT_API}/v1/localizacaochamada/buscaListarChamado`);
  }
  BuscarChamadaFiltros(filtros: ClienteModel) {
    return this.http.post<Resposta<ClienteModel[]>>(`${MEAT_API}/v1/localizacaochamada/listarLocalizacaoChamadoFiltros/`, filtros);
  }
  listarChamadaFiltros(dados: ClienteModel) {
    return this.http.post<Resposta<ClienteModel[]>>(`${MEAT_API}/api/cliente/buscaChamadaFiltros`, dados);
  }
  BuscarClienteFiltros(filtros: ClienteModel) {
    return this.http.post<Resposta<ClienteModel[]>>(`${MEAT_API}/api/cliente/buscaChamada`, filtros);
  }
  listarLocalizacaoCliente(dados: ClienteModel) {
    return this.http.post<Resposta<ClienteModel[]>>(`${MEAT_API}/api/cliente/buscaLocalizacaoCliente`, dados);
  }
  listarVisita() {
    return this.http.get<Resposta<CodigoAtendimentoModel[]>>(`${MEAT_API}/api/cliente/listaVisita`);
  }
  listarResolvido() {
    return this.http.get<Resposta<TecnicaModel[]>>(`${MEAT_API}/api/cliente/listaResolvido`);
  }
  listarLocTecnico(dados: FuncionarioModel) {
    return this.http.post<Resposta<FuncionarioModel[]>>(`${MEAT_API}/api/cliente/buscaLocalizacaoTecnico`, dados);
  }
  listarLocCliente(dados: ClienteModel) {
    return this.http.post<Resposta<ClienteModel[]>>(`${MEAT_API}/api/cliente/buscaLocCliente`, dados);
  }
  // listarTecnicoClienteFiltros(dados: ClienteModel) {
  //   return this.http.post<Resposta<ClienteModel[]>>(`${MEAT_API}/api/cliente/buscaLocalizacaoTecnicoClienteFiltros`, dados);
  // }
  BuscarTecnicoClienteFiltros(filtros: ClienteModel) {
    return this.http.post<Resposta<ClienteModel[]>>(`${MEAT_API}/api/cliente/buscaLocalizacaoTecnicoClienteFiltros`, filtros);
  }
  listarTecnicoCliente(dados: FuncionarioModel) {
    return this.http.post<Resposta<FuncionarioModel[]>>(`${MEAT_API}/api/cliente/buscaTecnicoCliente`, dados);
  }
  /////////////////

  //FATURAMENTO
  listarFaturamento(dados: FaturamentoModel) {
    return this.http.post<Resposta<FaturamentoModel[]>>(`${MEAT_API}/api/cliente/buscaFaturamento`, dados);
  }
  listarFaturamentoOrigem(dados: ContasReceberModel) {
    return this.http.post<Resposta<ContasReceberModel[]>>(`${MEAT_API}/api/cliente/buscaFaturamentoOrigem`, dados);
  }
}
